import React from "react";
import {
  HeartIcon,
  ShieldCheckIcon,
  UsersIcon,
  TrophyIcon,
  CheckBadgeIcon,
  ClockIcon,
  CheckCircleIcon, // ✅ use this instead of TargetIcon
} from "@heroicons/react/24/solid";

export default function About() {
  return (
    <section id="about" className="px-6 md:px-16 py-20 bg-white">
      {/* Top Section */}
      <div className="grid md:grid-cols-2 gap-12 items-center">
        {/* Left Content */}
        <div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Why Choose <span className="text-blue-900">PJS Service?</span>
          </h2>
          <p className="text-gray-600 mb-6">
            Depuis 2025, PJG SERVICES accompagne particuliers et entreprises dans l’entretien de leurs espaces. 
            Nous croyons que la propreté est essentielle au bien-être et à la performance. 
            C’est pourquoi nous mettons un point d’honneur à offrir un service fiable, humain et adapté à chaque besoin.
          </p>

          {/* Features */}
          <div className="space-y-5">
            <div className="flex items-start space-x-4">
              <ShieldCheckIcon className="w-6 h-6 text-blue-900 flex-shrink-0" />
              <div>
                <h4 className="font-semibold text-gray-900">
                  Professionnels certifiés
                </h4>
                <p className="text-gray-600 text-sm">
                  Pour votre tranquillité d'esprit, notre équipe est entièrement formée, 
                  assurée et a fait l'objet d'une vérification des antécédents
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <HeartIcon className="w-6 h-6 text-blue-900 flex-shrink-0" />
              <div>
                <h4 className="font-semibold text-gray-900">
                  Axé sur le client
                </h4>
                <p className="text-gray-600 text-sm">
                 Nous adaptons nos services à vos besoins spécifiques et dépassons vos attentes.
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <CheckCircleIcon className="w-6 h-6 text-blue-900 flex-shrink-0" />
              <div>
                <h4 className="font-semibold text-gray-900">
                  Garantie de qualité
                </h4>
                <p className="text-gray-600 text-sm">
                  Satisfaction garantie à 100% ou nous&apos;Nous reviendrons corriger le problème sans frais supplémentaires.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Image */}
        <div className="relative">
          <img
            src="/images/about.jpg"
            alt="PJS Service Team"
            className="rounded-lg shadow-lg"
          />
          {/* Badge */}
          <div className="absolute bottom-6 right-6 bg-blue-900 text-white px-4 py-3 rounded-lg shadow">
            <p className="text-lg font-bold">5+</p>
            <p className="text-sm">Années d'excellence</p>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="grid md:grid-cols-4 gap-6 mt-16 text-center">
        <div className="bg-gray-50 rounded-lg p-6">
          <UsersIcon className="w-8 h-8 text-blue-900 mx-auto mb-3" />
          <h3 className="text-2xl font-bold text-gray-900">500+</h3>
          <p className="text-gray-600 text-sm">Clients satisfaits</p>
        </div>

        <div className="bg-gray-50 rounded-lg p-6">
          <TrophyIcon className="w-8 h-8 text-blue-900 mx-auto mb-3" />
          <h3 className="text-2xl font-bold text-gray-900">5+</h3>
          <p className="text-gray-600 text-sm">Années d'expérience</p>
        </div>

        <div className="bg-gray-50 rounded-lg p-6">
          <CheckBadgeIcon className="w-8 h-8 text-blue-900 mx-auto mb-3" />
          <h3 className="text-2xl font-bold text-gray-900">100%</h3>
          <p className="text-gray-600 text-sm">Taux de satisfaction</p>
        </div>

        <div className="bg-gray-50 rounded-lg p-6">
          <ClockIcon className="w-8 h-8 text-blue-900 mx-auto mb-3" />
          <h3 className="text-2xl font-bold text-gray-900">24/7</h3>
          <p className="text-gray-600 text-sm">Assistance disponible</p>
        </div>
      </div>
    </section>
  );
}
